import React from 'react';
import { Switch, Route, useRouteMatch } from 'react-router-dom';
import NotificationList from './NotificationList';
import CreateNotification from './CreateNotification';
import PageContentError from '../UI/PageContentError';
import WizardBulkNotifications from '../WizardBulkNotifications';

const NotificationRoute = () => {
  const match = useRouteMatch();
  const { path } = match;

  return (
    <Switch>
      <Route exact path={path} render={(props) => <NotificationList {...props} />} />
      <Route path={`${path}/new`} component={CreateNotification} />
      <Route path={`${path}/bulk`} component={WizardBulkNotifications} />
      <Route path='*' component={PageContentError} />
    </Switch>
  );
};

export default NotificationRoute;
